import { TbQuote } from "solid-icons/tb";
import { type Component, Show, createSignal, onCleanup } from "solid-js";
import { twMerge } from "tailwind-merge";

/**
 * Displays a quoted text reference in chat message history.
 * Read-only component styled to match PromptBarQuote with hover expansion.
 */
export const QuoteDisplay: Component<{ quote: string }> = (props) => {
  const [popOut, setPopOut] = createSignal(false);

  let hoverTimeout: NodeJS.Timeout | undefined;
  let focusTimeout: NodeJS.Timeout | undefined;

  const handleHoverStart = () => {
    hoverTimeout = setTimeout(() => {
      setPopOut(true);
    }, 500);
  };

  const handleHoverEnd = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = undefined;
    }
    setPopOut(false);
  };

  const handleFocus = () => {
    focusTimeout = setTimeout(() => {
      setPopOut(true);
    }, 500);
  };

  const handleBlur = () => {
    if (focusTimeout) {
      clearTimeout(focusTimeout);
      focusTimeout = undefined;
    }
    setPopOut(false);
  };

  onCleanup(() => {
    if (hoverTimeout) clearTimeout(hoverTimeout);
    if (focusTimeout) clearTimeout(focusTimeout);
  });

  return (
    <div class="pt-1 mb-0 relative">
      <div
        tabindex={0}
        class="relative animate-fade-in transition-all select-none cursor-pointer flex items-start gap-2 rounded-t-[1.2rem] bg-inset px-6 py-2 pt-3"
        onMouseEnter={handleHoverStart}
        onMouseLeave={handleHoverEnd}
        onFocus={handleFocus}
        onBlur={handleBlur}
      >
        <TbQuote class="text-disabled-text flex-shrink-0" />
        <p
          class={twMerge(
            "whitespace-pre-wrap transition-all h-full max-h-[2.9rem] overflow-y-hidden text-xs text-left flex-1",
            popOut() && "max-h-[6.6rem] overflow-y-auto",
          )}
        >
          {props.quote}
        </p>
        <Show when={!popOut()}>
          <div class="pointer-events-none absolute left-0 right-0 bottom-0 h-10 rounded-b-[1.2rem] bg-gradient-to-b from-transparent to-inset" />
        </Show>
      </div>
    </div>
  );
};
